import React, { Fragment, useEffect } from "react";
import { FormattedMessage as FM } from "react-intl";
import { classNames } from "tools/ui";
import { CheckIcon, XMarkIcon } from "components/Icons";
import { Transition } from "@headlessui/react";

export const Alert = ({
  text = "app.booking.alert_msg_default",
  color = "bg-red-200",
  position = "relative",
  onClose,
  show = false,
  children,
  autoRemove = false,
  icon = "xmark",
  className = "",
  values,
}) => {
  useEffect(() => {
    if (autoRemove && show) {
      let timer;
      timer = setTimeout(() => {
        onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  return (
    <Fragment>
      <Transition
        show={show}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        className="w-full"
      >
        <div
          className={classNames(
            color,
            "p-4 pr-20 rounded-md flex items-center shadow-md space-x-3 ",
            position,
            className,
          )}
        >
          {children ? (
            children
          ) : (
            <span>
              {icon == "xmark" ? (
                <XMarkIcon
                  className="w-8 h-8 cursor-pointer hover:text-black bg-red-950 text-red-300 rounded-full p-1 fill-current"
                  onClick={onClose}
                />
              ) : (
                <CheckIcon
                  className="w-8 h-8 cursor-pointer hover:text-black bg-green-200 text-green-900 rounded-full p-1 fill-current"
                  onClick={onClose}
                />
              )}
            </span>
          )}

          <span>
            <FM id={text} values={values} />
          </span>
        </div>
      </Transition>
    </Fragment>
  );
};
